import { Box, Flex, styled } from '@withjoy/joykit';
import { css, pxToRem } from '@withjoy/joykit/theme';

export const NexPrevButton = styled(Box)<{ side: 'left' | 'right' }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(32)};
  position: absolute;
  right: ${({ side }) => (side === 'left' ? 'auto' : 0)};
  left: ${({ side }) => (side === 'left' ? 0 : 'auto')};
`;

export const FilledNavButton = styled(NexPrevButton)`
  top: 0;
  bottom: 0;
  color: white;
  mask-image: linear-gradient(to bottom, transparent 10%, black 50%, transparent 90%);
  background: ${({ side }) => (side === 'left' ? 'linear-gradient(to right, rgba(0, 0, 0, 0.5), transparent)' : 'linear-gradient(to left, rgba(0, 0, 0, 0.5), transparent)')};
`;

export const MinimalNavButton = styled(NexPrevButton)`
  top: 50%;
  height: ${pxToRem(32)};
  border-radius: 50%;
  transform: translate(${({ side }) => (side === 'left' ? '12px ' : '-12px')}, -50%);
  background-color: #f7f7f7bf;
  border: 1px solid #ebebeb;
  filter: drop-shadow(0px 7px 16px rgba(0, 0, 0, 0.3)) drop-shadow(0px 10px 27px rgba(44, 41, 37, 0.25));
`;

export const DotsContainer = styled(Flex)`
  position: absolute;
  bottom: ${pxToRem(16)};
  left: 50%;
  transform: translateX(-50%);
  gap: ${pxToRem(8)};
  z-index: 1;
  overflow: hidden;
  width: ${pxToRem(6 * 5 + 8 * 4)}; // 5 dots + 4 gaps
  padding: ${pxToRem(8)} 0;
`;

export const DotsTrack = styled(Flex)<{ offset: number }>`
  display: flex;
  gap: ${pxToRem(8)};
  transform: translateX(${({ offset }) => pxToRem(offset)});
  transition: transform 0.3s ease;
`;

export const Dot = styled(Box)<{ active?: boolean }>`
  width: ${pxToRem(6)};
  height: ${pxToRem(6)};
  border-radius: 50%;
  background-color: ${({ active }) => (active ? 'white' : 'rgba(255, 255, 255, 0.5)')};
  transition: all 0.2s ease;
  cursor: pointer;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));
  flex-shrink: 0;

  &:hover {
    background-color: white;
  }
`;

export const Container = styled(Box)<{ visible: 'default' | 'hover'; hideSlider: boolean }>`
  ${NexPrevButton} {
    transition: opacity 0.3s;
    opacity: ${({ visible }) => (visible === 'default' ? 1 : 0)};
  }

  &:hover ${NexPrevButton} {
    opacity: 1;
  }

  ${({ hideSlider }) =>
    !hideSlider &&
    css`
      @media (hover: hover) and (pointer: fine) {
        .slick-track {
          cursor: grab;
        }

        .slick-track:active {
          cursor: grabbing;
        }
      }
    `}
`;

export const StyledImage = styled(Box)<{ aspectRatio?: string }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio || 'auto'};
`;
